import Http from "../../http";

class ZoneServices {
  static async findAll() {
    return Http.get("/zones");
  }
}

export default ZoneServices;
